interface AclRole {
  id: number;
  alias: string;
}

interface JWTToken {
  networkAccount: boolean;
  userId: number;
  roles: string[];
  aclRoles?: AclRole[];
  iat: number;
  exp: number;
}

function decodeJwtToken(token: string): JWTToken | null {
  const base64Payload = token.split('.')[1];

  if (!base64Payload) {
    return null;
  }

  try {
    return JSON.parse(atob(base64Payload)) as JWTToken;
  } catch {
    return null;
  }
}

export default function getRolesFromToken(token: string): AclRole[] {
  const decodedToken = decodeJwtToken(token);

  if (!decodedToken) {
    return [];
  }

  // Проверяем, является ли пользователь суперадмином
  if (decodedToken.roles.includes('kernel_super_admin')) {
    return [{ id: -1, alias: 'kernel_super_admin' }];
  }

  // В остальных случаях возвращаем ACL роли
  return decodedToken.aclRoles || [];
}

export function getUserIdFromToken(token: string): number | null {
  const decodedToken = decodeJwtToken(token);

  return decodedToken?.userId ?? null;
}
